import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const FilterIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 16 17"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M7.052 10.6667H9.71866C9.88858 10.6669 10.052 10.7319 10.1756 10.8486C10.2991 10.9652 10.3735 11.1246 10.3834 11.2943C10.3934 11.4639 10.3382 11.6309 10.2292 11.7612C10.1201 11.8915 9.96539 11.9753 9.79666 11.9953L9.71866 12H7.052C6.88208 11.9998 6.71864 11.9347 6.59508 11.8181C6.47153 11.7015 6.39717 11.542 6.38721 11.3724C6.37726 11.2028 6.43245 11.0357 6.54151 10.9054C6.65057 10.7751 6.80526 10.6914 6.974 10.6713L7.052 10.6667ZM5.71866 7.33333H11.052C11.2219 7.33352 11.3854 7.39859 11.5089 7.51523C11.6325 7.63188 11.7068 7.7913 11.7168 7.96093C11.7267 8.13056 11.6715 8.29759 11.5625 8.42789C11.4534 8.55819 11.2987 8.64193 11.13 8.662L11.052 8.66667H5.71866C5.54874 8.66648 5.38531 8.60141 5.26175 8.48477C5.13819 8.36812 5.06384 8.2087 5.05388 8.03907C5.04392 7.86944 5.09911 7.70241 5.20817 7.57211C5.31723 7.44181 5.47193 7.35807 5.64066 7.338L5.71866 7.33333ZM3.71866 4H13.052C13.2219 4.00019 13.3854 4.06525 13.5089 4.1819C13.6325 4.29855 13.7068 4.45797 13.7168 4.6276C13.7267 4.79722 13.6715 4.96425 13.5625 5.09455C13.4534 5.22486 13.2987 5.3086 13.13 5.32867L13.052 5.33333H3.71866C3.54874 5.33315 3.38531 5.26808 3.26175 5.15143C3.13819 5.03479 3.06384 4.87536 3.05388 4.70574C3.04392 4.53611 3.09911 4.36908 3.20817 4.23878C3.31723 4.10848 3.47193 4.02474 3.64066 4.00467L3.71866 4Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(FilterIcon);
